export default __webpack_public_path__ + "static/images/app-phone-1x-48ddd9c30cd00d0d10b346ac09beebfd.png";